// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Wn-z","slideIn":"Xn-z"};